import React from 'react';
import classNames from 'classnames';

import css from './Sections.module.css';

/**
 * The landing sections' shared header: a small eyebrow line over the section title (h2).
 * `onDark` is for sections on the brand green.
 */
const SectionHeader = ({ eyebrow, title, onDark = false, className }) => (
  <div className={classNames(css.sectionHeader, className)}>
    {eyebrow ? (
      <p className={classNames(css.eyebrow, { [css.eyebrowOnDark]: onDark })}>{eyebrow}</p>
    ) : null}
    <h2 className={classNames(css.sectionTitle, { [css.sectionTitleOnDark]: onDark })}>
      {title}
    </h2>
  </div>
);

export default SectionHeader;
